"use strict";
var _EntityRollingProgramme_getUnpausingAdjustment;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityRollingProgramme = exports.isEntityRollingProgrammeConstructorProps = exports.isEntityRollingProgramme = void 0;
const tslib_1 = require("tslib");
const core_services_1 = require("@iotv/core-services");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const uuid_1 = require("uuid");
const ModelTypes_1 = require("../../../types/ModelTypes");
const ProgrammeTypes_1 = require("../../../types/ProgrammeTypes");
const lambda_1 = require("../../../util/lambda");
const helpers_1 = require("../../../util/time/helpers");
const ModelCommon_1 = require("../../ModelCommon");
const rollingScheduleFns_1 = require("./rollingScheduleFns");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const reasonableSeconds = (0, helpers_1.getReasonableTimestampSecondsFilter)(10, 10);
const reasonableWindowcount = (0, helpers_1.getReasonableValueNumber)(1, 1000);
const isEntityRollingProgramme = (x) => {
    const c = x;
    const isConstructorProps = (0, exports.isEntityRollingProgrammeConstructorProps)(x);
    const isInstance = c instanceof EntityRollingProgramme;
    const isEntityProgramme = isConstructorProps && isInstance;
    if (c && !isEntityProgramme) {
        ;
        c?.type === 'EntityProgramme' &&
            console.log(`WARN isEntityProgramme returning false for EntityProgramme ${c.id} with`, { isConstructorProps, isInstance });
    }
    return isEntityProgramme;
};
exports.isEntityRollingProgramme = isEntityRollingProgramme;
const isEntityRollingProgrammeConstructorProps = (x) => {
    const { startTimeUtcSeconds, name, windows } = x ?? {};
    const isEntityRollingProgrammeConstructorProps = typeof name === 'string' && (startTimeUtcSeconds === null || (0, iotv_v3_types_1.isNonNaNNumber)(startTimeUtcSeconds)) && (windows === null || (0, iotv_v3_types_1.isNonNaNNumber)(windows));
    if (!isEntityRollingProgrammeConstructorProps) {
        ;
        x?.type === 'EntityProgramme' &&
            console.log(`WARN isEntityProgrammeConstructorProps returning false  for EntityProgramme ${x?.id} with`, { name, windows, startTimeUtcSeconds });
    }
    return isEntityRollingProgrammeConstructorProps;
};
exports.isEntityRollingProgrammeConstructorProps = isEntityRollingProgrammeConstructorProps;
class EntityRollingProgramme extends ModelCommon_1.ModelCommon {
    constructor({ id = (0, uuid_1.v4)(), supportedType, enabled, maxNumberOfEntitiesPerTimeslot, name, windows, startTimeUtcSeconds, durationMins, windowGapDurationMins, cycleGapDurationMins, appliedTimestampsMs, durationMinsEach, continueWindowCount, valves, mvcControls, ...others }) {
        super('EntityRollingProgramme', { id, ...others });
        this.maxAppliedTimestamps = 50;
        this.getValveIDS = () => {
            return this.valves ?? [];
        };
        this.getDurationToWindow = (windowIdx) => {
            const defaultDuration = this.durationMins ?? 0;
            const durationUpToWindow = this.durationMinsEach
                ? this.durationMinsEach.slice(0, windowIdx).reduce((acc, cur) => {
                    acc += cur !== null ? cur : defaultDuration;
                    return acc;
                }, 0)
                : defaultDuration * windowIdx;
            return durationUpToWindow;
        };
        /**
         * Supporting function that returns the duration of that particular window, or the default
         */
        this.getWindowDuration = (windowIdx) => {
            if (windowIdx === undefined) {
                return this.durationMins ?? null;
            }
            return this.durationMinsEach && this.durationMinsEach[windowIdx] ? this.durationMinsEach[windowIdx] : this.durationMins;
        };
        /** returns the total cycle time - time in mins for the gap between cycles and the product of number of windows and ( durationMins + gapBetweenWindowsMins )  */
        this.getTotalRepeatTimeMins = () => {
            // sum all duration
            if (this.windows && this.durationMins) {
                // duration array is sliced in case the duration array is not maintained as the window count changes
                const nonNullDurations = this.durationMinsEach ? this.durationMinsEach.slice(0, this.windows).filter((val) => val !== null) : [];
                const definedDuration = nonNullDurations.reduce((acc, cur) => {
                    acc += cur;
                    return acc;
                }, 0);
                const totalDuration = definedDuration + (this.windows - (nonNullDurations?.length ?? 0)) * this.durationMins;
                return totalDuration + this.cycleGapDurationMins + this.windows * this.windowGapDurationMins;
            }
            return null;
        };
        /** returns the calculated delayMins to apply to each rollingProgammeConfig, based on the number of windows, specified duration, gap between windows and gap between cycles
         * the device enters delay phase first then operation phase (durationMins) so every config incluing the first starts with the calculated delay
         */
        this.getCalculatedDelayMins = (windowIdx) => {
            const duration = this.getWindowDuration(windowIdx);
            return this.windows && duration ? this.getTotalRepeatTimeMins() - duration : null;
        };
        _EntityRollingProgramme_getUnpausingAdjustment.set(this, (windowIdx) => {
            let shiftTimeMinutes = 0;
            // check should not be required, and should be done before it is called
            if (this.continueWindowCount && this.continueWindowCount > 0) {
                if (windowIdx < this.continueWindowCount) {
                    // add time of one complete cycle
                    shiftTimeMinutes += this.getTotalRepeatTimeMins() ?? 0;
                }
                // shift time such that windowIdx starts 30 minutes from now
                const unshiftAmount = this.getDurationToWindow(this.continueWindowCount);
                shiftTimeMinutes -= unshiftAmount ?? 0;
            }
            return shiftTimeMinutes * 60;
        }
        /** returns a rollingPatternConfig for any window index */
        );
        /** returns a rollingPatternConfig for any window index */
        this.getRollingProgrammeConfigForWindowIdx = (windowIdx, mvcPaddingMin = 0) => {
            let res = null;
            const { 
            // durationMins: genericDuration,
            windows, startTimeUtcSeconds: programmeStartTimeUtcSeconds, windowGapDurationMins,
            // cycleGapDurationMins,
             } = this;
            let delayMins = this.getCalculatedDelayMins(windowIdx);
            let durationMins = this.getWindowDuration(windowIdx);
            if (durationMins && windows && programmeStartTimeUtcSeconds && delayMins) {
                if ((0, core_services_1.between)(windowIdx, 0, windows)) {
                    const durationUpToWindow = this.getDurationToWindow(windowIdx);
                    const windowGapsDuration = windowGapDurationMins * windowIdx;
                    let startTimeUtcSeconds = programmeStartTimeUtcSeconds + (windowGapsDuration + durationUpToWindow) * 60;
                    // shift time due to pause
                    if (this.continueWindowCount && this.continueWindowCount > 0) {
                        const adjustmentTime = tslib_1.__classPrivateFieldGet(this, _EntityRollingProgramme_getUnpausingAdjustment, "f").call(this, windowIdx);
                        startTimeUtcSeconds += adjustmentTime;
                    }
                    if (mvcPaddingMin !== 0) {
                        const secondShift = mvcPaddingMin * 60;
                        if (windowIdx === 0) {
                            // start time shift back
                            startTimeUtcSeconds -= secondShift;
                            // duration increase
                            durationMins += mvcPaddingMin;
                            // delay decrease
                            delayMins -= mvcPaddingMin;
                        }
                        if (this.windows && windowIdx === this.windows - 1) {
                            // duration increase
                            durationMins += mvcPaddingMin;
                            // delay decrease
                            delayMins -= mvcPaddingMin;
                        }
                    }
                    res = {
                        delay: delayMins,
                        duration: durationMins,
                        moistureThreshold: 0,
                        startTimeUtcSeconds,
                    };
                    /** TAG: DISABLED PROGRAMME PROVISION */
                    if (this.enabled === false) {
                        res.delay = 0;
                        res.duration = 0;
                    }
                }
                else {
                    console.log(`WARN getRollingProgrammeConfigForWindowIdx ${windowIdx} is out of bounds, max is ${windows - 1}`);
                }
            }
            else {
                console.log(`WARN: getRollingProgrammeConfigForWindowIdx failing predicate`, {
                    durationMins,
                    windows,
                    programmeStartTimeUtcSeconds,
                    windowGapDurationMins,
                });
            }
            return res;
        };
        /** returns current and next info for each window, as an array with each index representing window idx */
        this.getCurrentAndNextScheduledInfo = (relativeDate) => {
            const arr = Array.from({ length: this.windows ?? 0 }, (v, i) => {
                const rollingPatternConfig = this.getRollingProgrammeConfigForWindowIdx(i);
                return rollingPatternConfig && (0, rollingScheduleFns_1.getCurrentAndNextScheduledInfo)({ relativeDate, rollingPatternConfig });
            });
            return arr;
        };
        /** Programme for controller MVC */
        this.getOverallProgramme = (startPadding, endPadding) => {
            const windows = this.windows ?? 0;
            const duration = this.durationMins ?? 0;
            const gap = this.windowGapDurationMins ?? 0;
            const cycleGap = this.cycleGapDurationMins ?? 0;
            let originalDurationMins = windows * (duration + gap);
            let bufferChangeSeconds = 0;
            // let startAction: 'add' | 'subtract' = 'add'
            if (this.mvcControls) {
                if (this.mvcControls.valveStartFirst) {
                    // startAction = 'subtract'
                    bufferChangeSeconds -= startPadding;
                }
                else {
                    bufferChangeSeconds += startPadding;
                }
                // if (this.mvcControls.valveEndFirst) {
                //   bufferChangeSeconds -= endPadding
                // } else {
                //   bufferChangeSeconds += endPadding
                // }
            }
            else {
                // using old format
                bufferChangeSeconds = startPadding; // + endPadding
            }
            let individualDuration;
            if (this.durationMinsEach) {
                individualDuration = this.durationMinsEach.map((val) => (val !== null ? val : duration));
                let durationOnly = individualDuration.reduce((acc, cur) => {
                    acc += cur;
                    return acc;
                }, 0) +
                    (individualDuration.length - windows) * duration;
                let windowOnly = gap * windows;
                originalDurationMins = durationOnly + windowOnly;
            }
            let combinedDuration = originalDurationMins + Math.round(bufferChangeSeconds / 60);
            return {
                delay: cycleGap,
                duration: combinedDuration,
                moistureThreshold: 0,
                startTimeUtcSeconds: Math.floor(this.startTimeUtcSeconds ?? Date.now() / 1000) + bufferChangeSeconds,
            };
        };
        this.getCurrentWindowAndSchedule = (relativeDate = new Date()) => this.getCurrentAndNextScheduledInfo(relativeDate).reduce((a, currentNextInfo, windowIdx) => {
            if (!a) {
                if (currentNextInfo?.isInDelayPhase === false) {
                    const rollingPatternConfig = this.getRollingProgrammeConfigForWindowIdx(windowIdx);
                    if (rollingPatternConfig) {
                        a = {
                            currentNextInfo,
                            rollingPatternConfig,
                            windowIdx,
                        };
                    }
                }
            }
            return a;
        }, null);
        this.updateAppliedTimestamps = (timestampMs) => {
            if (!this.appliedTimestampsMs) {
                this.appliedTimestampsMs = [];
            }
            this.appliedTimestampsMs?.unshift(timestampMs);
            this.appliedTimestampsMs = this.appliedTimestampsMs.slice(0, this.maxAppliedTimestamps);
        };
        /* the intention here was to fully enforce reasonablness but arbitrary construction from Assembler will error if this is left to deal with undefined*/
        if (startTimeUtcSeconds && !reasonableSeconds(startTimeUtcSeconds))
            throw new Error(`${startTimeUtcSeconds} ${new Date(startTimeUtcSeconds * iotv_v3_types_1.Milliseconds.SECOND)} is not a reasonable timestamp in seconds`);
        this.maxNumberOfEntitiesPerTimeslot = maxNumberOfEntitiesPerTimeslot ?? null;
        this.name = name;
        this.supportedType = supportedType;
        this.enabled = enabled ?? true;
        this.startTimeUtcSeconds = startTimeUtcSeconds ?? 0;
        this.durationMins = durationMins ?? 1;
        this.windows = reasonableWindowcount(windows) ? windows : 1;
        this.windowGapDurationMins = windowGapDurationMins ?? 1;
        this.cycleGapDurationMins = cycleGapDurationMins ?? 1;
        this.appliedTimestampsMs = appliedTimestampsMs ?? null;
        this.durationMinsEach = durationMinsEach ?? Array(this.windows).fill(null);
        this.continueWindowCount = continueWindowCount ?? null;
        this.valves = valves ?? [];
        this.mvcControls = mvcControls ?? {
            valveEndFirst: false,
            valveStartFirst: false,
        };
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            supportedType: {
                type: 'Enum',
                editable: true,
                required: true,
                enumKv: ProgrammeTypes_1.ProgrammeSupportedTypesEnum,
            },
            enabled: {
                type: 'Boolean',
                editable: true,
                required: true,
                default: true,
            },
            startTimeUtcSeconds: {
                type: 'Date',
                editable: true,
                precision: ModelTypes_1.UserAttributeKeyDatePrecision.DateTimeMins,
                label: 'Start Time',
                displayFn: (v) => v * iotv_v3_types_1.Milliseconds.SECOND,
                valueFn: (v) => v / iotv_v3_types_1.Milliseconds.SECOND,
            },
            windows: {
                type: 'Number',
                editable: true,
                precision: 0,
                label: 'Windows',
                default: 1,
                limits: { min: 1 },
            },
            durationMins: {
                type: 'Number',
                editable: true,
                precision: 0,
                label: 'Duration',
                units: 'mins',
                default: 1,
                limits: { min: 1 },
            },
            windowGapDurationMins: {
                type: 'Number',
                editable: true,
                precision: 0,
                label: 'Window Gap',
                units: 'mins',
                default: 1,
            },
            cycleGapDurationMins: {
                type: 'Number',
                editable: true,
                precision: 0,
                label: 'Cycle Gap',
                units: 'mins',
                default: 1,
            },
        };
    }
}
exports.EntityRollingProgramme = EntityRollingProgramme;
_EntityRollingProgramme_getUnpausingAdjustment = new WeakMap();
